import React from 'react';
import { LegalPage } from '../landing/LegalPage';

export function PrivacyView() {
    return <LegalPage kind="privacy" />;
}
